// import React, { useEffect, useState, useContext } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import CircularProgress from "@mui/material/CircularProgress";
// import { searchs } from "../Services/Service";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { createStyles, makeStyles } from "@mui/styles";
// import { style } from "@mui/system";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faAngleLeft,
//   faCircleChevronLeft,
// } from "@fortawesome/free-solid-svg-icons";

// const darkTheme = createTheme({
//   palette: {
//     mode: "dark",
//   },
// });

// const useStyles = makeStyles(() => ({
//   "css-9425fu-MuiOutlinedInput-notchedOutline": {
//     border: "none",
//     borderStyle: "hidden",
//   },
// }));

// // const useStyles = makeStyles(() =>
// //   createStyles({
// //     "makeStyles-css-9425fu-MuiOutlinedInput-notchedOutline-1": {
// //       // backgroundColor: "red",
// //       borderStyle:"hidden"
// //     },
// //   }),
// // );
// function Header({ count }) {
//   const nav = useNavigate();
//   const location = useLocation();
//   // const {func} = useContext(UserState)
//   const [open, setOpen] = React.useState(false);
//   const [options, setOptions] = React.useState([]);
//   // console.log(location.pathname)
//   const loading = open && options.length === 0;
//   const classes = useStyles();
//   const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//   useEffect(() => {
//     let active = true;

//     if (!loading) {
//       return undefined;
//     }

//     (async () => {
//       const data = await searchs(); // For demo purposes.

//       if (active) {
//         // console.log(data.data)
//         setOptions([...data.data.data]);
//       }
//     })();

//     return () => {
//       active = false;
//     };
//   }, [loading]);

//   useEffect(() => {
//     if (!open) {
//       setOptions([]);
//     }
//   }, [open]);
//   // document.getElementsByClassName('css-9425fu-MuiOutlinedInput-notchedOutline').style.borderStyle = "hidden";
//   return (
//     <>
//       {/* <div className="circleblurbg"></div> */}
//       {location.pathname !== "/auth-login" &&
//         location.pathname !== "/csv" &&
//         location.pathname !== "/penta" &&
//         location.pathname.slice(0, 5) !== "/t&cp" &&
//         location.pathname.slice(0, 2) !== "/s" && (
//           <header className="headerMain">
//             <nav className="navbar navbar-expand-lg fixed-top nav-bg" style={{zIndex:'100'}}>
//               <span
//                 onClick={() => {
//                   return nav(-1);
//                 }}
//                 style={
//                   location.pathname === "/home"
//                     ? { visibility: "hidden" }
//                     : { visibility: "visible", paddingLeft: "10px" }
//                 }
//               >
//                 <FontAwesomeIcon icon={faCircleChevronLeft} />
//               </span>
//               <Link to="/home">
//                 <img
//                   style={localStorage.getItem("theme") === "light" ? {} : {}}
//                   src={
//                     localStorage.getItem("theme") === "light"
//                       ? "/assets/images/icespice-logo.png"
//                       : "/assets/images/icespice-logo.png"
//                   }
//                   alt="IceSpice Logo"
//                   className="logo"
//                   height="36"
//                 />
//               </Link>
//               <div className="navbar-right">
//                 <div className="search">
//                   {location.pathname === "/home" && (
//                     <form action="#" className="search-bar">
//                       <input
//                         type="text"
//                         placeholder="Search..."
//                         name="search"
//                         onFocus={() => {
//                           return nav("/category", { state: true });
//                         }}
//                       />
//                       <button
//                         onClick={(e) => {
//                           e.preventDefault();
//                           return nav("/category", { state: true });
//                         }}
//                       >
//                         <img
//                           src={"/assets/images/Search-Icon.png"}
//                           alt="Seach Icon"
//                         />
//                       </button>
//                     </form>
//                   )}
//                   {/* <ThemeProvider theme={darkTheme}>
//                 <Autocomplete
//       id="asynchronous-demo"
//       sx={{ width: 200}}
//       open={open}
//       onOpen={() => {
//         setOpen(true);
//       }}
//       onClose={() => {
//         setOpen(false);
//       }}
//       isOptionEqualToValue={(option, value) => option.productTitle === value.productTitle}
//       getOptionLabel={(option) => option.productTitle}
//     renderOption={(props, option, i) => {
//         return (
//             <Link to = {`/productdetails/${option.productId}`}><li {...props} key={option.productId + i}>
//             {option.productTitle}
//           </li></Link>
//         );
//       }}
//       options={options}
//       loading={loading}
//       renderInput={(params) => (
//         <TextField
//             id
//           {...params}
//           label="Search"
//           className="search-bar"
//           // outline: 'none'
//           // variant="standard"
//           InputProps={{
//             outline: 'none',
//             borderStyle:"none",
//             // disableUnderline: true,
//             ...params.InputProps,
//             endAdornment: (
//               <React.Fragment>
//                 {loading ? <CircularProgress color="inherit" size={20} /> : null}
//                 {params.InputProps.endAdornment}
//               </React.Fragment> 
//             ),
//           }}
//         />
//       )}
//     />
//     </ThemeProvider> */}
//                   {location.pathname !== "/home" && (
//                     <button
//                       className="icon searchIco"
//                       aria-label="searchIcon"
//                       style={
//                         location.pathname === "/category"
//                           ? { visibility: "hidden" }
//                           : { visibility: "visible" }
//                       }
//                       onClick={() => {
//                         return nav("/category", { state: true });
//                       }}
//                     ></button>
//                   )}
//                   {/* <div className="hedrInner">
//   <div className="InformationHeader">
//     <div className="hdLeftBtn">
//       <button aria-label="backIcon" type="button" className="icon backIco" />
//       <div className="search-icon-wrapper">
//         <img
//           src="https://www.tatacliq.com/src/assets/images/icons/search-active_ssr.svg"
//           alt="active-search-icon"
//         />
//       </div>
//     </div>
//     <div className="hedInput">
//       <input
//         type="text"
//         placeholder="What are you looking for?"
//         id="search-text-input"
//         autoComplete="off"
//         defaultValue="fau"
//       />
//     </div>
//     <div className="cross-icon-wrapper">
//       <img
//         src="https://www.tatacliq.com/src/assets/images/icons/search-cross_ssr.svg"
//         alt="search-cross-icon"
//       />
//     </div>
//   </div>
// </div> */}
//                 </div>
//               </div>
//             </nav>
//           </header>
//         )}
//     </>
//   );
// }
// export default Header;

import logo from './icespice-logo.png'
import { Link ,useNavigate,useLocation } from 'react-router-dom'
import React from "react";

const Header = () => {
    const nav = useNavigate();
    const location = useLocation();
  return (
    <>
     {location.pathname !== "/auth-login" &&
         location.pathname !== "/csv" &&
         location.pathname !== "/penta" &&
         location.pathname.slice(0, 5) !== "/t&cp" &&
         location.pathname.slice(0, 2) !== "/s" &&

         <header>
         <div className="top-bar fixed-top py-2">
          <div className="container">
              <div className="d-flex justify-content-between align-items-center pb-1">
                  <div className="d-flex justify-content-between align-items-center">
                  <i onClick={()=>{return nav(-1)}} style={location.pathname==="/"?{display:"none"}:{display:"block"}} class="fa fa-chevron-circle-left"></i>
                  <Link className="navbar-brand ms-1" to="/home">
                      <img src={logo} alt="" />
                  </Link>
                  </div>
                  {location.pathname !== "/category" &&
                            <div className="d-flex position-relative top-search">
                            <Link to='/category'>
                            <input className="form-control me-2 search-bar" type="search" placeholder="Search" aria-label="Search"/>
                            <i className="fa fa-search"></i>
                            </Link>
                        </div>
                  }
              
                
              </div>
          </div>
          </div>
       
         </header>

}
      
    </>
  )
}

export default Header